module.exports = __webpack_public_path__ + "static/media/awad3.67e662f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/awad3.png
// module id = 1310
// module chunks = 0